import React from "react"
import { Box } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"


export default function dateColumn() {
	return {
		name: "timestamp_create_user",
		render: value => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
			{formatDate(value, {
				isString: true,
				format: 'dd MMM yyyy HH:mm',
				receivedFormat: dateFormatReceiver(value)
			})}
		</Box>
	}
}